<template>
  <el-table v-loading="loading" :data="reportTableData.dataList">
    <el-table-column
        v-for="key in reportTableData.colNameList"
        :key="key"
        :prop="key"
        :label="key">
      <template slot-scope="scope">
        <div v-if="typeof scope.row[key] === 'string' || !scope.row[key]">{{scope.row[key]}}</div>
        <div v-else :style="{color: scope.row[key].color ? scope.row[key].color : '' }">{{ scope.row[key].inputResult || '' }} {{ scope.row[key].resultFlagShow || '' }}</div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>

import {getUserReport} from "@/api/biz/ReportUserTotal";

export default {
  props: {
    user: {
      type: Object
    }
  },
  data() {
    return {
      loading: true,
      reportTableData: {
        dataList:[],
        colNameList:[]
      },
    };
  },
  mounted() {
    this.getUserReport();
  },
  methods: {
    getUserReport() {
      this.reportTableData= {
        dataList:[],
        colNameList:[]
      }
      this.loading = true;
      getUserReport( this.user.id ).then(response => {
        console.log(response)
        this.loading = false;
        this.reportTableData = response.data;
      })
    },
    close() {
      this.$tab.closePage();
    }
  }
};
</script>
